import { produce } from 'immer';
import { GlFormGroup, GlForm, GlFormRadioGroup, GlButton, GlAlert } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import WorkItemTokenInput from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/shared/work_item_token_input.vue?vue3';
import addLinkedItemsMutation from '../../graphql/add_linked_items.mutation.graphql';
import workItemLinkedItemsQuery from '../../graphql/work_item_linked_items.query.graphql';
import { findLinkedItemsWidget } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/utils.js?vue3';
import { LINKED_ITEM_TYPE_VALUE, MAX_WORK_ITEMS } from '../../constants';
export default {
    name: 'WorkItemAddRelationshipForm',
    components: {
        GlForm,
        GlButton,
        GlFormGroup,
        GlFormRadioGroup,
        GlAlert,
        WorkItemTokenInput
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    props: {
        isGroup: {
            type: Boolean,
            required: false,
            default: false
        },
        workItemId: {
            type: String,
            required: false,
            default: null
        },
        workItemIid: {
            type: String,
            required: false,
            default: null
        },
        workItemFullPath: {
            type: String,
            required: false,
            default: null
        },
        childrenIds: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        hasBlockedWorkItemsFeature: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'cancel',
        'submitted'
    ],
    data () {
        return {
            linkedItemType: LINKED_ITEM_TYPE_VALUE.RELATED,
            linkedItemTypes: [
                {
                    text: this.$options.i18n.relatedToLabel,
                    value: LINKED_ITEM_TYPE_VALUE.RELATED
                },
                {
                    text: this.$options.i18n.blockingLabel,
                    value: LINKED_ITEM_TYPE_VALUE.BLOCKS
                },
                {
                    text: this.$options.i18n.blockedByLabel,
                    value: LINKED_ITEM_TYPE_VALUE.BLOCKED_BY
                }
            ],
            workItemsToAdd: [],
            error: null,
            showWorkItemsToAddInvalidMessage: false,
            isSubmitting: false,
            maxWorkItems: MAX_WORK_ITEMS
        };
    },
    computed: {
        workItemsToAddInvalidMessage () {
            return this.$options.i18n.addChildErrorMessage;
        },
        isSubmitButtonDisabled () {
            return this.workItemsToAdd.length <= 0 || !this.areWorkItemsToAddValid;
        },
        areWorkItemsToAddValid () {
            return this.workItemsToAdd.length <= this.maxWorkItems;
        },
        errorMessage () {
            return !this.areWorkItemsToAddValid ? this.$options.i18n.maxItemsErrorMessage : '';
        }
    },
    methods: {
        async linkWorkItem () {
            try {
                this.isSubmitting = true;
                const { data: { workItemAddLinkedItems: { errors } } } = await this.$apollo.mutate({
                    mutation: addLinkedItemsMutation,
                    variables: {
                        input: {
                            id: this.workItemId,
                            linkType: this.linkedItemType,
                            workItemsIds: this.workItemsToAdd.map((wi)=>wi.id)
                        },
                        useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                    },
                    update: (cache, { data: { workItemAddLinkedItems: { workItem } } })=>{
                        const queryArgs = {
                            query: workItemLinkedItemsQuery,
                            variables: {
                                fullPath: this.workItemFullPath,
                                iid: this.workItemIid,
                                useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                            }
                        };
                        const sourceData = cache.readQuery(queryArgs);
                        if (!sourceData) {
                            return;
                        }
                        cache.writeQuery({
                            ...queryArgs,
                            data: produce(sourceData, (draftState)=>{
                                const linkedItemsWidget = findLinkedItemsWidget(draftState.namespace.workItem);
                                linkedItemsWidget.linkedItems = findLinkedItemsWidget(workItem)?.linkedItems;
                            })
                        });
                    }
                });
                if (errors.length > 0) {
                    [this.error] = errors;
                    return;
                }
                this.workItemsToAdd = [];
                this.unsetError();
                this.showWorkItemsToAddInvalidMessage = false;
                this.linkedItemType = LINKED_ITEM_TYPE_VALUE.RELATED;
                this.$emit('submitted');
            } catch (e) {
                this.error = this.$options.i18n.addLinkedItemErrorMessage;
            } finally{
                this.isSubmitting = false;
            }
        },
        unsetError () {
            this.error = null;
        }
    },
    i18n: {
        addButtonLabel: __('Add'),
        relatedToLabel: s__('WorkItem|relates to'),
        blockingLabel: s__('WorkItem|blocks'),
        blockedByLabel: s__('WorkItem|is blocked by'),
        linkItemInputLabel: s__('WorkItem|the following items'),
        addLinkedItemErrorMessage: s__('WorkItem|Something went wrong when trying to link a item. Please try again.')
    }
};
